import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CircularProgress, Box } from "@mui/material";
import { getMe } from "../../features/auth";
import { qk } from "../../lib";
import { ROUTES } from "../utils";

export const ProtectedRoute: React.FC = () => {
  const location = useLocation();

  const { data: session, isLoading, isError } = useQuery({
    queryKey: qk.me(),
    queryFn: getMe
  });

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !session?.authenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (session.needs_new_password) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (location.pathname === "/") {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};
